module.exports = __webpack_public_path__ + "static/img/yuan.943077af.png";